import { paths } from '../../common/constants/pathVariables';
import { corporateCustomersMsg, subscriptionsMsg, t } from '../../common/i18n';
import { BreadCrumbs } from '../BreadCrumbs';

export const PublicMobileVoiceBreadcrumbs = () => (
  <BreadCrumbs
    breadCrumbPaths={[
      { name: t.KBLX(corporateCustomersMsg), path: '/' },
      { name: t.JPRH(subscriptionsMsg), path: paths.SUBSCRIPTIONS_PUBLIC },
      { name: t.HV3R('Voice subscriptions') },
    ]}
  />
);
